import { u8aToU8a } from '@polkadot/util';
/** @internal */
export function createDecode(_ref, validate) {
  let {
    coder,
    ipfs
  } = _ref;
  return (value, ipfsCompat) => {
    validate(value, ipfsCompat);
    return coder.decode(ipfs && ipfsCompat ? value.substring(1) : value);
  };
}
/** @internal */
export function createEncode(_ref2) {
  let {
    coder,
    ipfs
  } = _ref2;
  return (value, ipfsCompat) => {
    const out = coder.encode(u8aToU8a(value));
    return ipfs && ipfsCompat ? "".concat(ipfs).concat(out) : out;
  };
}
/** @internal */
export function createIs(validate) {
  return (value, ipfsCompat) => {
    try {
      return validate(value, ipfsCompat);
    } catch {
      return false;
    }
  };
}
/** @internal */
export function createValidate(_ref3) {
  let {
    chars,
    ipfs,
    type
  } = _ref3;
  return (value, ipfsCompat) => {
    if (typeof value !== 'string') {
      throw new Error("Expected ".concat(type, " string input"));
    } else if (ipfs && ipfsCompat && value[0] !== ipfs) {
      throw new Error("Expected ipfs-compatible ".concat(type, " to start with '").concat(ipfs, "'"));
    }
    for (let i = ipfsCompat ? 1 : 0, count = value.length; i < count; i++) {
      if (!(chars.includes(value[i]) || value[i] === '=' && (i === value.length - 1 || !chars.includes(value[i + 1])))) {
        throw new Error("Invalid ".concat(type, " character \"").concat(value[i], "\" (0x").concat(value.charCodeAt(i).toString(16), ") at index ").concat(i));
      }
    }
    return true;
  };
}